export default __webpack_public_path__ + "static/media/mody-vision-logo.4035d23b.png";